"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  DATA_EVENT: "data"
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvZXZlbnRzLmpzIl0sIm5hbWVzIjpbIkRBVEFfRVZFTlQiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUFlO0FBQ2JBLGNBQVk7QUFEQyxDIiwiZmlsZSI6ImV2ZW50cy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcbiAgREFUQV9FVkVOVDogXCJkYXRhXCJcbn07XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/luggage/lib/constants/events.js
// module id = 35
// module chunks = 0